module.exports = __webpack_public_path__ + "img/SingingInTheRain.ddbcfc41.jpg";